import { createSlice, nanoid, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, AppDispatch } from "../../../store";
import { azureSimpleRecommendationsState } from "./azureSimpleRecommendationsTypes";
import { getRestAzureSimpleRecommendations } from "../../../api/azureSimpleRecommendationsStore";
import { ResourceRecommendation } from "lib/ShiOneClient";

const initialState: azureSimpleRecommendationsState = {
  azureSimpleRecommendationsFetchStatus: "idle",
  azureSimpleRecommendations: [],
};

const azureSimpleRecommendationsSlice = createSlice({
  name: "azureSimpleRecommendations",
  initialState,
  reducers: {
    receivingAzureSimpleRecommendations(
      state,
      action: PayloadAction<{ requestId: string }>
    ) {
      state.azureSimpleRecommendationsFetchStatus = "loading";
      state.latestRequestId = action.payload.requestId;
    },
    receivedAzureSimpleRecommendations(
      state,
      action: PayloadAction<{
        requestId: string;
        recommendations: ResourceRecommendation[];
      }>
    ) {
      // Only the latest request may win, even if an earlier one targeted the same subscription.
      if (action.payload.requestId !== state.latestRequestId) {
        return;
      }
      state.azureSimpleRecommendations = action.payload.recommendations;
      state.azureSimpleRecommendationsFetchStatus = "complete";
    },
    receiveAzureSimpleRecommendationsError(
      state,
      action: PayloadAction<{ requestId: string }>
    ) {
      if (action.payload.requestId !== state.latestRequestId) {
        return;
      }
      state.azureSimpleRecommendationsFetchStatus = "error";
    },
  },
});

export const getAzureSimpleRecommendations =
  (subscriptionId: string): AppThunk =>
  async (dispatch: AppDispatch) => {
    const requestId = nanoid();
    dispatch(
      azureSimpleRecommendationsSlice.actions.receivingAzureSimpleRecommendations(
        { requestId }
      )
    );

    try {
      const simpleRecommendations = await getRestAzureSimpleRecommendations(
        subscriptionId
      );
      dispatch(
        azureSimpleRecommendationsSlice.actions.receivedAzureSimpleRecommendations(
          { requestId, recommendations: simpleRecommendations }
        )
      );
    } catch {
      dispatch(
        azureSimpleRecommendationsSlice.actions.receiveAzureSimpleRecommendationsError(
          { requestId }
        )
      );
    }
  };

export default azureSimpleRecommendationsSlice.reducer;
